import React, { useEffect } from 'react';
import { Analytics } from '@indigo-ag/ui-core';
import { AppContainer } from '@indigo-ag/component-module';

import { Routes } from 'core/components/Routes/Routes';
import { history } from 'store';
import { globalTranslations } from 'core/i18n';

export const Root: React.FunctionComponent = () => {
  useEffect(() => {
    Analytics.initialize();
  }, []);

  return (
    <AppContainer
      navigationTitle="Indigo Financing Admin"
      navigationLogoName="indigo"
      onNavigate={history.push}
      globalTranslations={globalTranslations}
    >
      <Routes />
    </AppContainer>
  );
};
